import { schema } from 'normalizr';
import pulseSurveySchema from './pulseSurvey';

const pulseSurveyDetailedAnalytics = new schema.Entity(
  'pulseSurveysDetailedAnalytics',
  {
    pulseSurvey: pulseSurveySchema,
  },
  {
    idAttribute: entity => entity.groupByValue?.periodStartDate || entity.groupByValue,
  },
);

export default pulseSurveyDetailedAnalytics;
